import { State } from '@meraki-internal/state';

// TODO: consolidate OrgNavigationMenuState??
export type ISelectedNavItem = 'caremap' | 'caregiver' | 'care' | undefined;

export class NavigationMenuState extends State<{isOpen: boolean, selectedNavItem: ISelectedNavItem}> {
    constructor() {
        super({
            isOpen: false,
            selectedNavItem: 'caremap'
        });
    };

    setOpen = (isOpen: boolean) => {
        this.setState({ isOpen });
    };

    isOpen = () => {
        return Boolean(this.state?.isOpen);
    };

    setSelectedNavItem = (selectedNavItem: ISelectedNavItem) => {
        this.setState({ selectedNavItem });
    };
}
